module.exports = __webpack_public_path__ + "img/lighthouse.bae549ee.webp";